<template>
  <div>
    <vx-card title="Inbound - Customer Return">
      <vs-tabs value="2">
        <vs-tab @click="goPurchaseOrder" index="0" label="Purchase Order"></vs-tab>
        <vs-tab @click="goInterWarehouse" label="Inter Warehouse"></vs-tab>
        <vs-tab  index="2" label="Customer Return"></vs-tab>
        <vs-tab @click="goPodReturn" index="3" label="POD Return"></vs-tab>
      </vs-tabs>
      <div class="mt-3 ml-1 vx-row">
        <vs-tabs>
          <vs-tab label="Receive">
            <!-- <tab-received></tab-received> -->
          </vs-tab>
          <vs-tab label="HU Conversion">
            <!-- <tab-hu-conversion></tab-hu-conversion> -->
          </vs-tab>
          <vs-tab label="Check">
            <!-- <tab-check></tab-check> -->
          </vs-tab>
          <vs-tab label="Put-away">
            <!-- <tab-put-away></tab-put-away> -->
          </vs-tab>
          <vs-tab label="Complete">
            <!-- <tab-complete></tab-complete> -->
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>
<script>

export default {
  components: {

  },
  data() {
    return {
      activeTab: "Received",
      draw: 0,
      transactionDate: null,
      selectedSrcWarehouse: null
    }
  },
  methods: {
    handleFilter() {
      this.draw++;
    },
    goPurchaseOrder() {
      this.$router.push({
        name: this.$store.state.inbound.purchaseOrder.baseRouterName,
      });
    },
    goInterWarehouse() {
      this.$router.push({
        name: this.$store.state.inbound.interWarehouse.baseRouterName,
      });
    },
    goPodReturn() {
      this.$router.push({
        name: this.$store.state.inbound.podReturn.baseRouterName,
      });
    },
  }
}
</script>
